import { GuardedDeletionService, VendorCreateDto, VendorDto, VendorExcelDownloadDto, VendorService, VendorUpdateDto } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import { VENDOR_CONFIG, VENDOR_FIELDS } from './vendor.config';
import { BaseHierarchicalCrudComponent, GenericForm, ZnHierarchicalViewComponent } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-vendor',
  imports: [
    CommonModule,
    GenericForm,
    ZnHierarchicalViewComponent,
  ],
  providers: [ListService, VendorService, ConfirmationService],
  templateUrl: './vendor.html',
  styleUrl: './vendor.scss',
})
export class Vendor extends BaseHierarchicalCrudComponent<
  VendorDto,
  VendorCreateDto,
  VendorUpdateDto,
  VendorExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(VendorService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('Vendor', ids),
  };
  config = VENDOR_CONFIG;
  fields = VENDOR_FIELDS;

  protected prepareUpdateDto(data: any, selected: VendorDto): VendorUpdateDto {
    return {
      sapCode: data.sapCode,
      legalName: data.legalName,
      fantasyName: data.fantasyName,
      vatNumber: data.vatNumber,
      taxNumber: data.taxNumber,
      taxType: data.taxType,
      isSapDeleted: data.isSapDeleted,
      isGenericVendor: data.isGenericVendor,
      isOwnService: data.isOwnService,
      shouldAskForActivityReportAuthorization: data.shouldAskForActivityReportAuthorization,
      industryKey: data.industryKey,
      businessType: data.businessType,
      operationDgiId: data.operationDgiId,
      receptionAddress: data.receptionAddress,
      isDosesVendor: data.isDosesVendor,
      oldSapCode: data.oldSapCode,
      isMainVendor: data.isMainVendor,
      nameInitials: data.nameInitials,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Vendor';
  }
}
